import { render, staticRenderFns } from "./direct_message_queues_targets.vue?vue&type=template&id=23d521ec"
import script from "./direct_message_queues_targets.vue?vue&type=script&lang=ts"
export * from "./direct_message_queues_targets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports